import React, {
  useEffect,
  useRef,
  useState
} from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";

import {
  API_URL,
  getMediaUrl
} from "./config/api";

import sanitizeRichHtml from
  "./utils/sanitizeRichHtml";

  import {
  getSafeExternalUrl
} from "./utils/safeUrl";

function PostDetails({ posts }) {
  const { id } = useParams();

  const articleContentRef =
    useRef(null);

    const [lightboxIndex, setLightboxIndex] =
  useState(null);

const [linkCopied, setLinkCopied] =
  useState(false);

const [fetchedPost, setFetchedPost] =
  useState(null);

const [postFetchError, setPostFetchError] =
  useState(null);


const touchStartX =
  useRef(null);

const touchStartY =
  useRef(null);

const touchEndX =
  useRef(null);

const touchEndY =
  useRef(null);


const postFromList =
  Array.isArray(posts)
    ? posts.find(
        (p) => p._id === id
      )
    : null;


const post =
  postFromList ||
  (
    fetchedPost?._id === id
      ? fetchedPost
      : null
  );

  const safeVideoUrl =
  getSafeExternalUrl(
    post?.video
  );

  useEffect(() => {

  /*
   * If App.js has already loaded this post,
   * use that copy and do not make another request.
   */
  if (postFromList) {

    setFetchedPost(null);
    setPostFetchError(null);

    return undefined;

  }


  let ignoreResult = false;


  /*
   * We are starting a fresh lookup for this route.
   */
  setFetchedPost(null);
  setPostFetchError(null);


  const fetchPostById =
    async () => {

      try {

        const response =
          await axios.get(
            `${API_URL}/posts/${encodeURIComponent(id)}`
          );


        if (ignoreResult) {
          return;
        }


        setFetchedPost(
          response.data
        );

      }

      catch (error) {

        if (ignoreResult) {
          return;
        }


        console.error(
          "Error loading post:",
          error
        );


        setPostFetchError({
          id,
          type:
            error.response?.status === 404
              ? "not-found"
              : "error"
        });

      }

    };


  fetchPostById();


  return () => {

    /*
     * Ignore a response belonging to a route
     * the user has already left.
     */
    ignoreResult = true;

  };

}, [
  id,
  postFromList
]);

      useEffect(() => {
    if (!post?._id) {
      return;
    }

    const siteName = "Chatra Sangbad";
    const canonicalUrl =
      `https://chatrasangbad.org/post/${post._id}`;

    const cleanDescription =
      (post.content || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const description =
      cleanDescription.length > 160
        ? `${cleanDescription.slice(0, 157)}...`
        : cleanDescription ||
          `${post.title} | ${siteName}`;

    const imageUrl =
      getMediaUrl(
        post.coverImage || post.image
      );

    document.title =
      `${post.title} | ${siteName}`;

    const originalValues = [];

    const setMeta = (
      selector,
      attribute,
      value
    ) => {
      let element =
        document.head.querySelector(selector);

      if (element) {
        originalValues.push({
          element,
          content:
            element.getAttribute("content")
        });
      } else {
        element =
          document.createElement("meta");

        element.setAttribute(
          attribute,
          selector.includes('property=')
            ? selector.match(
                /property="([^"]+)"/
              )[1]
            : selector.match(
                /name="([^"]+)"/
              )[1]
        );

        document.head.appendChild(element);

        originalValues.push({
          element,
          content: null
        });
      }

      element.setAttribute(
        "content",
        value
      );
    };

    setMeta(
      'meta[name="description"]',
      "name",
      description
    );

    setMeta(
      'meta[property="og:type"]',
      "property",
      "article"
    );

    setMeta(
      'meta[property="og:site_name"]',
      "property",
      siteName
    );

    setMeta(
      'meta[property="og:title"]',
      "property",
      post.title
    );

    setMeta(
      'meta[property="og:description"]',
      "property",
      description
    );

    setMeta(
      'meta[property="og:url"]',
      "property",
      canonicalUrl
    );

    setMeta(
  'meta[property="article:section"]',
  "property",
  post.category || ""
);

setMeta(
  'meta[property="article:author"]',
  "property",
  post.writer || ""
);

if (post.publishDate) {
  let publishedTime = "";

  if (
    typeof post.publishDate === "string" &&
    /^\d{2}\/\d{2}\/\d{4}$/.test(
      post.publishDate
    )
  ) {
    const [
      day,
      month,
      year
    ] = post.publishDate
      .split("/")
      .map(Number);

    publishedTime =
      `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
  }

  if (publishedTime) {
    setMeta(
      'meta[property="article:published_time"]',
      "property",
      publishedTime
    );
  }
}

if (post.updatedAt) {
  setMeta(
    'meta[property="article:modified_time"]',
    "property",
    new Date(
      post.updatedAt
    ).toISOString()
  );
}

    setMeta(
      'meta[name="twitter:card"]',
      "name",
      imageUrl
        ? "summary_large_image"
        : "summary"
    );

    setMeta(
      'meta[name="twitter:title"]',
      "name",
      post.title
    );

    setMeta(
      'meta[name="twitter:description"]',
      "name",
      description
    );

        if (imageUrl) {
      setMeta(
        'meta[property="og:image"]',
        "property",
        imageUrl
      );

      setMeta(
        'meta[property="og:image:secure_url"]',
        "property",
        imageUrl
      );

      setMeta(
        'meta[property="og:image:alt"]',
        "property",
        post.title
      );

      setMeta(
        'meta[name="twitter:image"]',
        "name",
        imageUrl
      );

      setMeta(
        'meta[name="twitter:image:alt"]',
        "name",
        post.title
      );
    }

    let canonical =
      document.head.querySelector(
        'link[rel="canonical"]'
      );

    const canonicalWasExisting =
      Boolean(canonical);

    const originalCanonical =
      canonical?.getAttribute("href");

    if (!canonical) {
      canonical =
        document.createElement("link");

      canonical.setAttribute(
        "rel",
        "canonical"
      );

      document.head.appendChild(canonical);
    }

    canonical.setAttribute(
      "href",
      canonicalUrl
    );

    return () => {
      document.title =
  "ছাত্র সংবাদ | Chatra Sangbad";

      originalValues.forEach(
        ({ element, content }) => {
          if (content === null) {
            element.remove();
          } else {
            element.setAttribute(
              "content",
              content
            );
          }
        }
      );

      if (canonicalWasExisting) {
        canonical.setAttribute(
          "href",
          originalCanonical || ""
        );
      } else {
        canonical.remove();
      }
    };
  }, [
  post?._id,
  post?.title,
  post?.content,
  post?.category,
  post?.writer,
  post?.publishDate,
  post?.updatedAt,
  post?.coverImage,
  post?.image
]);

    useEffect(() => {
    if (
      !post?._id ||
      (post.type && post.type !== "article")
    ) {
      return;
    }

    const cleanDescription =
      (post.content || "")
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();

    const description =
      cleanDescription.length > 160
        ? `${cleanDescription.slice(0, 157)}...`
        : cleanDescription ||
          `${post.title} | Chatra Sangbad`;

    const canonicalUrl =
      `https://chatrasangbad.org/post/${post._id}`;

    const imageUrl =
      getMediaUrl(
        post.coverImage || post.image
      );

    let datePublished = "";

    if (
      typeof post.publishDate === "string" &&
      /^\d{2}\/\d{2}\/\d{4}$/.test(
        post.publishDate
      )
    ) {
      const [
        day,
        month,
        year
      ] = post.publishDate
        .split("/")
        .map(Number);

      datePublished =
        `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    } else if (post.createdAt) {
      datePublished =
        new Date(
          post.createdAt
        ).toISOString();
    }

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": post.title,
"description": description,
"articleSection": post.category || undefined,
"mainEntityOfPage": {
        "@type": "WebPage",
        "@id": canonicalUrl
      },
      "datePublished": datePublished || undefined,
"dateModified": post.updatedAt
  ? new Date(post.updatedAt).toISOString()
  : undefined,
"author": post.writer
        ? {
            "@type": "Person",
            "name": post.writer
          }
        : {
            "@type": "Organization",
            "name": "Chatra Sangbad"
          },
      "publisher": {
  "@type": "Organization",
  "name": "Chatra Sangbad",
  "logo": {
    "@type": "ImageObject",
    "url": "https://chatrasangbad.org/logo.png"
  }
},
      ...(imageUrl
        ? {
            "image": [imageUrl]
          }
        : {})
    };

    const script =
      document.createElement("script");

    script.type =
      "application/ld+json";

    script.setAttribute(
      "data-chatra-article-schema",
      "true"
    );

    script.textContent =
      JSON.stringify(
        structuredData,
        null,
        2
      );

    document.head.appendChild(
      script
    );

    return () => {
      document.head
        .querySelectorAll(
          'script[data-chatra-article-schema="true"]'
        )
        .forEach(
          (element) =>
            element.remove()
        );
    };
    }, [
    post?._id,
    post?.type,
    post?.title,
    post?.content,
post?.publishDate,
post?.writer,
post?.category,
post?.updatedAt,
post?.coverImage,
post?.image
  ]);
    const getSubcategoryLabel = (subcategory) => {
  if (subcategory === "Science") {
    return "Science & Technology";
  }

  if (
    subcategory === "Cultural" ||
    subcategory === "Culture" ||
    subcategory === "Ink and Echo"
  ) {
    return "Ink & Echo";
  }

  return subcategory;
};

  const getCategoryLabel = (category) =>
    category === "Photos & Videos" ||
    category === "PhotosVideos"
      ? "Media"
      : category;

  useEffect(() => {

    if (!post?._id) {
      return;
    }

    // Do not count Admin views
    if (localStorage.getItem("isAdmin") === "true") {
      return;
    }

    axios
      .post(
        `${API_URL}/api/posts/${post._id}/view`
      )
      .catch((error) => {
        console.error(
          "Error incrementing post view count:",
          error
        );
      });

    }, [post?._id]);


  useEffect(() => {

    const articleContent =
      articleContentRef.current;

    if (
      !articleContent ||
      !post?.content
    ) {
      return;
    }

    let animationFrameId =
      null;

    const positionAnchoredShapes =
      () => {

        if (
          animationFrameId !== null
        ) {
          window.cancelAnimationFrame(
            animationFrameId
          );
        }

        animationFrameId =
          window.requestAnimationFrame(
            () => {

              animationFrameId =
                null;

              const images = [
                ...articleContent
                  .querySelectorAll(
                    "img.editor-uploaded-image"
                  )
              ];

              const wrappers = [
                ...articleContent
                  .querySelectorAll(
                    [
                      '[data-rich-text-shape="true"]',
                      "[data-shape-anchor-image-index]",
                      "[data-shape-anchor-center-y-ratio]"
                    ].join("")
                  )
              ];

              wrappers.forEach(
                (wrapper) => {

                  wrapper.style
                    .removeProperty(
                      "--shape-anchor-correction-y"
                    );

                }
              );

              /*
              Force layout after removing an
              earlier correction.
              */
              articleContent
                .getBoundingClientRect();

              wrappers.forEach(
                (wrapper) => {

                  const imageIndex =
                    Number(
                      wrapper.getAttribute(
                        "data-shape-anchor-image-index"
                      )
                    );

                  const centreYRatio =
                    Number(
                      wrapper.getAttribute(
                        "data-shape-anchor-center-y-ratio"
                      )
                    );

                  const anchorImage =
                    images[imageIndex];

                  const shape =
                    wrapper.querySelector(
                      ".rich-text-shape-surface"
                    );

                  if (
                    !Number.isInteger(
                      imageIndex
                    ) ||
                    !Number.isFinite(
                      centreYRatio
                    ) ||
                    !anchorImage ||
                    !shape
                  ) {
                    return;
                  }

                  const imageRectangle =
                    anchorImage
                      .getBoundingClientRect();

                  const shapeRectangle =
                    shape
                      .getBoundingClientRect();

                  if (
                    imageRectangle.height <= 0
                  ) {
                    return;
                  }

                  const desiredCentreY =
                    imageRectangle.top +
                    centreYRatio *
                    imageRectangle.height;

                  const currentCentreY =
                    shapeRectangle.top +
                    shapeRectangle.height /
                      2;

                  const correctionY =
                    desiredCentreY -
                    currentCentreY;

                  wrapper.style
                    .setProperty(
                      "--shape-anchor-correction-y",
                      `${correctionY}px`
                    );

                }
              );

            }
          );

      };

        const images = [
      ...articleContent
        .querySelectorAll(
          "img.editor-uploaded-image"
        )
    ];

    let layoutSettleTimeoutId =
      null;

    const positionAfterLayoutSettles =
      () => {

        positionAnchoredShapes();

        if (
          layoutSettleTimeoutId !== null
        ) {
          window.clearTimeout(
            layoutSettleTimeoutId
          );
        }

        /*
        Run again after responsive image and
        container layout has completely settled.
        */
        layoutSettleTimeoutId =
          window.setTimeout(
            () => {

              layoutSettleTimeoutId =
                null;

              positionAnchoredShapes();

            },
            250
          );

      };

    images.forEach((image) => {

      image.addEventListener(
        "load",
        positionAfterLayoutSettles
      );

      if (image.complete) {
        positionAfterLayoutSettles();
      }

    });

    positionAfterLayoutSettles();

    window.addEventListener(
      "resize",
      positionAfterLayoutSettles
    );

    const resizeObserver =
      window.ResizeObserver
        ? new window.ResizeObserver(
            positionAfterLayoutSettles
          )
        : null;

    if (resizeObserver) {

      resizeObserver.observe(
        articleContent
      );

      images.forEach((image) => {
        resizeObserver.observe(image);
      });

    }

        return () => {

      if (
        animationFrameId !== null
      ) {
        window.cancelAnimationFrame(
          animationFrameId
        );
      }

      if (
        layoutSettleTimeoutId !== null
      ) {
        window.clearTimeout(
          layoutSettleTimeoutId
        );
      }

      images.forEach((image) => {
        image.removeEventListener(
          "load",
          positionAfterLayoutSettles
        );
      });

      window.removeEventListener(
        "resize",
        positionAfterLayoutSettles
      );

      resizeObserver?.disconnect();

    };

  }, [
    post?._id,
    post?.content
  ]);

 const galleryImages =
  Array.isArray(post?.images) &&
  post.images.length > 0
    ? post.images.filter(
        imageItem =>
          imageItem?.url
      )
    : post?.image
    ? [
        {
          url: post.image,
          publicId:
            post.imagePublicId || ""
        }
      ]
    : [];

    const closeLightbox = () => {
  setLightboxIndex(null);
};


const showPreviousPhoto = () => {

  if (galleryImages.length <= 1) {
    return;
  }

  setLightboxIndex(
    currentIndex => {

      if (currentIndex === null) {
        return 0;
      }

      return (
        currentIndex - 1 +
        galleryImages.length
      ) % galleryImages.length;

    }
  );

};


const showNextPhoto = () => {

  if (galleryImages.length <= 1) {
    return;
  }

  setLightboxIndex(
    currentIndex => {

      if (currentIndex === null) {
        return 0;
      }

      return (
        currentIndex + 1
      ) % galleryImages.length;

    }
  );

};

useEffect(() => {

  if (lightboxIndex === null) {
    return;
  }

  const previousOverflow =
    document.body.style.overflow;

  document.body.style.overflow =
    "hidden";


  const handleKeyDown = (event) => {

    if (event.key === "Escape") {
      setLightboxIndex(null);
      return;
    }


    if (
      event.key === "ArrowLeft" &&
      galleryImages.length > 1
    ) {

      setLightboxIndex(
        currentIndex =>
          (
            currentIndex - 1 +
            galleryImages.length
          ) % galleryImages.length
      );

    }


    if (
      event.key === "ArrowRight" &&
      galleryImages.length > 1
    ) {

      setLightboxIndex(
        currentIndex =>
          (
            currentIndex + 1
          ) % galleryImages.length
      );

    }

  };


  window.addEventListener(
    "keydown",
    handleKeyDown
  );


  return () => {

    window.removeEventListener(
      "keydown",
      handleKeyDown
    );

    document.body.style.overflow =
      previousOverflow;

  };

}, [
  lightboxIndex,
  galleryImages.length
]);

const handleLightboxTouchStart =
  (event) => {

    const touch =
      event.touches[0];

    touchStartX.current =
      touch.clientX;

    touchStartY.current =
      touch.clientY;

    touchEndX.current = null;
    touchEndY.current = null;

  };


const handleLightboxTouchMove =
  (event) => {

    const touch =
      event.touches[0];

    touchEndX.current =
      touch.clientX;

    touchEndY.current =
      touch.clientY;

  };


const handleLightboxTouchEnd =
  () => {

    if (
      touchStartX.current === null ||
      touchEndX.current === null
    ) {
      return;
    }


    const horizontalDistance =
      touchStartX.current -
      touchEndX.current;

    const verticalDistance =
      touchStartY.current -
      touchEndY.current;


    const isHorizontalSwipe =
      Math.abs(horizontalDistance) >
      Math.abs(verticalDistance);


    const minimumSwipeDistance = 50;


    if (
      isHorizontalSwipe &&
      Math.abs(horizontalDistance) >=
        minimumSwipeDistance
    ) {

      // Swipe left
      if (horizontalDistance > 0) {
        showNextPhoto();
      }

      // Swipe right
      else {
        showPreviousPhoto();
      }

    }


    touchStartX.current = null;
    touchStartY.current = null;

    touchEndX.current = null;
    touchEndY.current = null;

  };


  if (!post) {

  const currentFetchError =
    postFetchError?.id === id
      ? postFetchError
      : null;


  if (!currentFetchError) {

    return (

      <main
        className="post-details"
        aria-busy="true"
        aria-label="Loading article"
      >

        <article className="article-container">

          <h2
            style={{
              padding: "40px",
              margin: 0
            }}
          >
            Loading article...
          </h2>

        </article>

      </main>

    );

  }


  if (
    currentFetchError.type ===
    "not-found"
  ) {

    return (

      <main className="post-details">

        <article className="article-container">

          <h2
            style={{
              padding: "40px",
              margin: 0
            }}
          >
            Post not found
          </h2>

        </article>

      </main>

    );

  }


  return (

    <main className="post-details">

      <article className="article-container">

        <h2
          style={{
            padding: "40px",
            margin: 0
          }}
        >
          Unable to load this post right now.
        </h2>

      </article>

    </main>

  );

}

const canonicalShareUrl =
  `https://chatrasangbad.org/post/${post._id}`;

const whatsappShareText =
  `${post.title}\n\n${canonicalShareUrl}`;

const whatsappShareUrl =
  `https://wa.me/?text=${encodeURIComponent(
    whatsappShareText
  )}`;

  const facebookShareUrl =
  `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
    canonicalShareUrl
  )}`;

const handleCopyLink = async () => {

  try {

    await navigator.clipboard.writeText(
      canonicalShareUrl
    );

    setLinkCopied(true);

    window.setTimeout(() => {
      setLinkCopied(false);
    }, 2000);

  } catch (error) {

    console.error(
      "Unable to copy link:",
      error
    );

    window.prompt(
      "Copy this link:",
      canonicalShareUrl
    );

  }

};

return (
  <main className="post-details">

        <article className="article-container">

      <header className="article-header-panel">

      <h1 className="article-title">
        {post.title}
      </h1>

               <div className="article-meta">

            <div className="article-meta-primary">

              <span>
  <strong>
    {getCategoryLabel(post.category)}
  </strong>

  {post.subcategory && (
    <>
      {" / "}
      {getSubcategoryLabel(post.subcategory)}
    </>
  )}

  {post.subSubcategory && (
    <>
      {" / "}
      {post.subSubcategory}
    </>
  )}
</span>

              <span
                className="article-meta-separator"
                aria-hidden="true"
              >
                •
              </span>

              <span>
                {new Date(post.createdAt).toLocaleDateString()}
              </span>

              {post.readingTime && (
                <>
                  <span
                    className="article-meta-separator"
                    aria-hidden="true"
                  >
                    •
                  </span>

                  <span>
                    {post.readingTime}
                  </span>
                </>
              )}

            </div>


            {(
              (
                post.category === "Articles" &&
                post.writer
              ) ||
              post.featured
            ) && (

              <div className="article-meta-secondary">

                {post.category === "Articles" &&
                  post.writer && (

                    <div className="article-meta-author">

                      <strong>By</strong>{" "}

                      <Link
  to={`/writer/${encodeURIComponent(post.writer)}`}
  className="writer-link"
  title={`View all articles by ${post.writer}`}
  aria-label={`View all articles by ${post.writer}`}
>
                        {post.writer}
                      </Link>

                    </div>

                  )}


                {post.featured && (

                  <span className="featured-badge">
                    ★ Featured
                  </span>

                )}

              </div>

            )}

          </div>

      </header>

<div className="post-share-actions">

  <span className="post-share-label">
    Share:
  </span>


  <a
    href={whatsappShareUrl}
    target="_blank"
    rel="noopener noreferrer"
    className="
      post-share-button
      post-share-button--whatsapp
    "
    aria-label={`Share ${post.title} on WhatsApp`}
    title="Share on WhatsApp"
  >

    <svg
      viewBox="0 0 32 32"
      aria-hidden="true"
      className="post-share-icon"
    >
      <path
        fill="currentColor"
        d="M16.04 3C8.86 3 3 8.75 3 15.82c0 2.27.61 4.49 1.77 6.43L3 29l6.97-1.82a13.2 13.2 0 0 0 6.06 1.47h.01C23.22 28.65 29 22.91 29 15.83 29 8.75 23.22 3 16.04 3Zm0 23.48a11.1 11.1 0 0 1-5.66-1.54l-.41-.24-4.13 1.08 1.1-4-.27-.42a10.65 10.65 0 0 1-1.65-5.54c0-5.88 4.94-10.66 11.02-10.66 6.07 0 11.01 4.78 11.01 10.66 0 5.88-4.94 10.66-11.01 10.66Zm6.04-7.98c-.33-.16-1.96-.94-2.27-1.05-.3-.1-.52-.16-.74.16-.22.32-.86 1.05-1.05 1.27-.19.21-.38.24-.71.08-.33-.16-1.4-.5-2.66-1.6-.98-.86-1.65-1.92-1.84-2.24-.19-.32-.02-.5.14-.66.15-.14.33-.37.5-.56.16-.18.22-.32.33-.53.11-.21.05-.4-.03-.56-.08-.16-.74-1.73-1.01-2.37-.27-.64-.54-.55-.74-.56h-.63c-.22 0-.57.08-.87.4-.3.32-1.15 1.1-1.15 2.68s1.18 3.11 1.34 3.32c.16.21 2.31 3.45 5.61 4.84.78.33 1.4.52 1.87.67.79.24 1.5.21 2.07.13.63-.09 1.96-.78 2.24-1.53.27-.75.27-1.39.19-1.53-.08-.13-.3-.21-.63-.37Z"
      />
    </svg>

    <span>
      WhatsApp
    </span>

  </a>


  <a
    href={facebookShareUrl}
    target="_blank"
    rel="noopener noreferrer"
    className="
      post-share-button
      post-share-button--facebook
    "
    aria-label={`Share ${post.title} on Facebook`}
    title="Share on Facebook"
  >

    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="post-share-icon"
    >
      <path
        fill="currentColor"
        d="M13.5 22v-9h3l.5-3.5h-3.5V7.3c0-1 .3-1.8 1.8-1.8H17V2.4c-.7-.1-1.5-.2-2.3-.2-2.3 0-4 1.4-4 4.1v3.2H8V13h2.7v9h2.8Z"
      />
    </svg>

    <span>
      Facebook
    </span>

  </a>


  <button
    type="button"
    className="
      post-share-button
      post-share-button--copy
    "
    onClick={handleCopyLink}
    aria-label="Copy post link"
    title="Copy link"
  >

    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      className="post-share-icon"
    >
      <path
        fill="currentColor"
        d="M8 7V5a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3h-2v-2h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v2H8Zm-3 1h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3Zm0 2a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1H5Z"
      />
    </svg>

    <span>
      {linkCopied
        ? "Copied!"
        : "Copy Link"}
    </span>

  </button>

</div>

<hr className="article-divider" />

      {post.type === "image" ? (

  <>

    {galleryImages.length > 0 && (

      <div
        className={
          galleryImages.length === 1
            ? "photo-post-gallery photo-post-gallery--single"
            : galleryImages.length === 2
            ? "photo-post-gallery photo-post-gallery--two"
            : "photo-post-gallery photo-post-gallery--multi"
        }
      >

        {galleryImages.map(
  (imageItem, index) => (

    <button
      key={
        imageItem.publicId ||
        imageItem.url ||
        index
      }
      type="button"
      className="photo-post-gallery-button"
      onClick={() =>
        setLightboxIndex(index)
      }
      aria-label={
        `Open photo ${index + 1} of ${galleryImages.length}`
      }
    >

      <img
        src={getMediaUrl(
          imageItem.url
        )}
        alt={
          galleryImages.length === 1
            ? post.title
            : `${post.title} - Photo ${index + 1}`
        }
        className="photo-post-gallery-image"
        loading={
          index === 0
            ? "eager"
            : "lazy"
        }
      />

    </button>

  )
)}

      </div>

    )}


    {post.content && (

      <div
        ref={articleContentRef}
        className="article-content"
        dangerouslySetInnerHTML={{
  __html:
    sanitizeRichHtml(
      post.content
    )
}}
      />

    )}

  </>

) : post.type === "video" || post.video ? (

        <>

      <div
        ref={articleContentRef}
        className="article-content"
      >

            <div
              dangerouslySetInnerHTML={{
  __html:
    sanitizeRichHtml(
      post.content
    )
}}
            />

            <br />

            {safeVideoUrl && (

  <a
    href={safeVideoUrl}
    target="_blank"
    rel="noopener noreferrer"
    className="watch-video-button"
  >
    <span className="watch-video-icon">
      ▶
    </span>

    <span>
      Watch Video
    </span>
  </a>

)}

          </div>

        </>

      ) : (

  <div
    ref={articleContentRef}
    className="article-content"
          dangerouslySetInnerHTML={{
  __html:
    sanitizeRichHtml(
      post.content
    )
}}
        />

      )}

    </article>

    {lightboxIndex !== null &&
  galleryImages[lightboxIndex] && (

    <div
      className="photo-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label="Photo viewer"
      onClick={closeLightbox}
    >

      <button
        type="button"
        className="photo-lightbox-close"
        onClick={(event) => {
          event.stopPropagation();
          closeLightbox();
        }}
        aria-label="Close photo viewer"
      >
        ×
      </button>


      {galleryImages.length > 1 && (

        <button
          type="button"
          className="photo-lightbox-arrow photo-lightbox-arrow--previous"
          onClick={(event) => {
            event.stopPropagation();
            showPreviousPhoto();
          }}
          aria-label="Previous photo"
        >
          ‹
        </button>

      )}


      <div
        className="photo-lightbox-stage"
        onClick={(event) =>
          event.stopPropagation()
        }
        onTouchStart={
          handleLightboxTouchStart
        }
        onTouchMove={
          handleLightboxTouchMove
        }
        onTouchEnd={
          handleLightboxTouchEnd
        }
      >

        <img
          src={getMediaUrl(
            galleryImages[
              lightboxIndex
            ].url
          )}
          alt={
            `${post.title} - Photo ${lightboxIndex + 1}`
          }
          className="photo-lightbox-image"
          draggable="false"
        />

      </div>


      {galleryImages.length > 1 && (

        <button
          type="button"
          className="photo-lightbox-arrow photo-lightbox-arrow--next"
          onClick={(event) => {
            event.stopPropagation();
            showNextPhoto();
          }}
          aria-label="Next photo"
        >
          ›
        </button>

      )}


      <div
        className="photo-lightbox-counter"
        onClick={(event) =>
          event.stopPropagation()
        }
      >
        {lightboxIndex + 1}
        {" / "}
        {galleryImages.length}
      </div>

    </div>

  )}

  </main>
);
}

export default PostDetails;